import { BUILDER_STEP_ORDER } from 'shared/consts';

import type { BuilderStep } from '../types';

/** Position of a step in the fixed builder order — the single basis for all step-order comparisons. */
export const getStepIndex = (step: BuilderStep) => BUILDER_STEP_ORDER.indexOf(step);
